import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
import utilities from './../../services/utility'
let service = new services();
let utility = new utilities();

export default {
    name: 'CnsurveyRequests',
    data () {
        return {
            user:{},
            businesses: [],
            businessCategories: {},
            states: [],
            surveys: {},
            survey: {},
            options: [],
            survey_questions: {},
            cities: {},
            panelFlag: false,
            addFlag: false,
            addQuestionFlag: false,
            editQuestionFlag: false,
            editFlag: false,
            deleteFlag: false,
            activateFlag: false,
            loadSurveyData: "",
            amount_paid: "",
            disable_btn: false
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "activate-survey"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = false;
                this.activateFlag = true;

                this.survey = attr2;
            }
            if(attr == "add"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if(attr == "edit"){
                this.editFlag = true;
                this.deleteFlag = false;
                this.addFlag = false;

                this.survey = attr2;
            }
            if(attr == "add-question"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = false;
                this.addQuestionFlag = true;

            }
            if(attr == "edit-question"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = false;
                this.editQuestionFlag = true;

                this.survey_questions = attr2;
            }
            if(attr == "delete"){
               
               this.panelFlag = false;
               this.survey = attr2;
               this.survey.deleteFlag = true;
            }
            if(attr == "delete-question"){
                this.survey_questions = attr2;
                this.survey_questions.deleteFlag = true;
                this.deleteFlag = true;
                
            }
            if(attr == "back"){
                location.reload(true);
            }
        },
        // Get users businesses
        getBusiness() {
           // let uid = utility.getUserToken();
           let uid = localStorage.getItem("cityneeds_token_key");
            service.getBusinesses(this, uid).then((res) => {
                this.businesses = res.body.data;
            })
        },
        //get businesses categories
         getBusinessCategories() {
            service.getBusinessCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.businessCategories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        // Getting user's surveys
        getCnsurveys() {
            let id = localStorage.getItem("cityneeds_token_key");
            service.getUserSurveys(this, id).then((res) => {
                this.surveys = res.body.data;
            })
        },

        // Getting states data
        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        // Get cities
        getCities(id) {
            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then((res) => {
                this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            })
        },
        setSurveyCategory(category){
            if(category == 4){
                this.loadSurveyData = "business";
                this.survey.cnsurvey_business_category = 0;
            }
            else{
                this.loadSurveyData = "business_categories";
                this.survey.cnsurvey_business = 0;
             }
        },
        next(sv,i){
           if(this.surveys[sv].cnsurveys_questions[i+1] == undefined){
            this.surveys[sv].cnsurvey_question_index = 0;
           }else{
                this.surveys[sv].cnsurvey_question_index++;
            }
        },
        // Create survey
        createSurvey() {
            let survey = this.survey;
            let options = this.options;
            survey.cnsurvey_user = this.user.user_id;
            survey.state = 15 //for default
            survey.cnsurvey_city = 1;//for default
           // survey.cnsurvey_options = [options.one, options.two, options.three, options.four, options.five];
           if((survey.cnsurvey_title != '') && (survey.cnsurvey_category)){
               if(((survey.cnsurvey_business) && (survey.cnsurvey_business != '')) || ((survey.cnsurvey_business_category) && (survey.cnsurvey_business_category != ''))){
                service.survey(this, survey).then((res) => {
                    if(res.status == 201) {
                        toastr.success("Survey submitted!", "Success!");
                        this.survey.cnsurvey_id = res.body.cnsurvey_status;
                        
                        //prepare add survey question flag
                        this.survey.cnsurveys_questions = [];
                        this.addQuestionFlag =  true;
                        this.addFlag = false;
                        //location.reload(true);
                    }else {
                        toastr.error("Couldn't complete request, kindly try again", "Warning!");
                    }
                })
               }else{
                    toastr.error("Complete all fields with *", "Warning!");
               }
            }else{
                toastr.error("Complete all fields with *", "Warning!");
           }
            
        },
        // Add Suvey Question
        addSurveyQuestion(attr) {
            let survey = this.survey;
            let options = this.options;
            survey.cnsurvey_options = [options.one, options.two, options.three, options.four, options.five];
            if(options.one != null){ //just to make sure its not empty
                service.addSurveyQuestion(this, survey).then((res) => {
                    if(res.status == 201) {
                    this.survey.cnsurveys_questions.length++;
                       toastr.success("Survey Question Added!", "Success!");
                        //this.$router.push({path: "your-surveys"});
                       // location.reload(true);
                       //this.survey = res.body.data;
                       this.survey.cnsurvey_question = "";
                       this.options = [];
                       if(attr == "finish"){
                        location.reload(true);
                        }
                    }else {
                        toastr.error("Couldn't complete request, kindly try again", "Warning!");
                    }
                })
            }
            
            if(survey.cnsurveys_questions.length == 4){
                location.reload(true);
            }
            
        },
         //get the answers for each option
        get_option_answer(option,survey_answers){
            let option_count = 0;
            if((survey_answers != null)){
                survey_answers.forEach(function(element) {
                    if(option == element.cnsurvey_answer_option){
                         option_count++;
                        }
                }, this);
                return option_count;
            } else{
                return 0;
            }
        },
        // Edit Survey
        editSurvey() {
            if((this.survey.cnsurvey_title != '') && (this.survey.cnsurvey_category)){
                if(((this.survey.cnsurvey_business) && (this.survey.cnsurvey_business != '')) || ((this.survey.cnsurvey_business_category) && (this.survey.cnsurvey_business_category != ''))){
                 
                    service.editSurvey(this, this.survey,this.survey.cnsurvey_id).then((res) => {
                        if(res.body.status == 200) {
                            toastr.success("Survey edited!", "Success!");
                            location.reload(true);
                        }else {
                            toastr.error("Couldn't complete request, kindly try again", "Warning!");
                        }
                    })
                }else{
                    toastr.error("Complete all fields with *", "Warning!");
               }
            }else{
                toastr.error("Complete all fields with *", "Warning!");
           }
        },
        // Edit Survey
         editSurveyQuestion() {
            //edit question
            service.editSurveyQuestion(this, this.survey_questions,this.survey_questions.cnsurvey_question_id).then((res) => {
                if(res.body.status == 200) {
                     toastr.success("Survey Question edited!", "Success!");
                     location.reload(true);
                 }else {
                     toastr.error("Couldn't complete request, kindly try again", "Warning!");
                 }
             })
         },
        // Delete Survey
        deleteSurvey() {
            service.deleteSurvey(this, this.survey.cnsurvey_id).then((res) => {
                 if(res.body.status == 200) {
                     toastr.success("Survey deleted!", "Success!");
                     location.reload(true);
                 }else {
                     toastr.error("Couldn't complete request, kindly try again", "Warning!");
                 }
             })
         },
         // Delete Survey Questions
        deleteSurveyQuestion() {
           service.deleteSurveyQuestion(this, this.survey_questions.cnsurvey_question_id).then((res) => {
                 if(res.body.status == 200) {
                     toastr.success("Survey Question deleted!", "Success!");
                     location.reload(true);
                 }else {
                     toastr.error("Couldn't complete request, kindly try again", "Warning!");
                 }
             })
         },
        
        //connect to a payment gateway
        processPayment(data) {

            this.disable_btn = true;

            let obj = this;
            this.amount_paid = data.payment_amount;
            var handler = PaystackPop.setup({
            //key: 'pk_test_5e386f2b137cecdea7db6839c293614a8a115742',
            key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
            Name: data.payment_user,
            //email: data.payment_user_email,
            email: "webworks@webnigeria.ng",
            amount: (data.payment_amount * 100), //in kobo
            ref: data.payment_ref,
            metadata: {
                custom_fields: [
                    {
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.payment_user
                    },
                    {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }
                    
                ]
            },
            
            callback: function(response){
                obj.updatePayment(response.trxref); 
                
            },
            onClose: function(){
                alert('window closed');
            }
            }); 
            handler.openIframe();
        },


        // update payments
        updatePayment(payment_ref) {
            var credentials = {
                amount_paid: this.amount_paid,
                payment_ref: payment_ref
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
                service.updateCnsurveysPayments(this, payment_ref, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        this.$router.go('/mymoney');
                    }else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
            toastr.error('Something went wrong', 'Warning!');
            }
            
        },
    },
    created: function(){
        this.preset();
        this.getBusiness();
        this.getBusinessCategories();
        this.getStates();
        this.getCnsurveys();
    }
  
}


// WEBPACK FOOTER //
// ./src/components/CnsurveyRequests/script.js